






































import {defineComponent, onUnmounted, reactive} from "@vue/composition-api"
import BaseLayout from "@/components/layout/BaseLayout.vue"
import {AppInstance, getMTEnvironments, MTEnvResponse, mtEnvUpgrade} from "@/data/repos/MTEnvironments"
import {requestWithNotification} from "@/notifications"
import Loading from "@/components/Loading.vue"

const REFRESH_INTERVAL = 15 * 1000 // Page refresh interval (ms)

export default defineComponent({
  name: "MultiTenantEnvironments",
  components: {BaseLayout, Loading},
  setup() {
    const state = reactive({
      envs: {} as MTEnvResponse,
      hasUpgrade(appInstance: AppInstance): string {
        const inss = state.envs.instances.filter(i => i.id === appInstance.id)
        const iidx = inss.findIndex(v => v.env === appInstance.env)
        if (iidx < inss.length - 1) {
          if (appInstance.version !== inss[iidx + 1].version) { return `Upgrade ${inss[iidx + 1].env}` }
        }
        return ""
      },
      getInstance(env: string, app: string): AppInstance {
        const instance = state.envs.instances.filter(i => i.id === app && i.env === env)
        return instance && instance.length > 0 ? instance[0] : {version: ""} as AppInstance
      },
      mtEnvUpgrade: async(app: string, env: string) => {
        const resp = await requestWithNotification(mtEnvUpgrade(app, env), "Upgrade initiated", "Request failed")
      },
    })

    const updateEnvs = async() => state.envs = (await getMTEnvironments()).payload || {} as MTEnvResponse
    setTimeout(updateEnvs, 0)
    const updateTimer = setInterval(updateEnvs, REFRESH_INTERVAL)
    onUnmounted(() => clearInterval(updateTimer))
    return state
  },
})
